const isExternalPath = (path = '') => path.startsWith('http');
export default isExternalPath;
//# sourceMappingURL=isExternalPath.js.map